import { render, staticRenderFns } from "./mod11.vue?vue&type=template&id=2c351a24&scoped=true&"
import script from "./mod11.vue?vue&type=script&lang=js&"
export * from "./mod11.vue?vue&type=script&lang=js&"
import style0 from "./mod11.vue?vue&type=style&index=0&id=2c351a24&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c351a24",
  null
  
)

export default component.exports